import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const Panel = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    height: 100%;
    background-color: ${kcc.colors.GRAY_300};
    overflow: hidden;
    padding: ${kcc.spacing.BASE} ${kcc.spacing.XS};
  `}
`;

export const MapLayer = styled.div`
  position: absolute;
  inset: 0;
`;
